import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from '@/helpers/classNames'
import InlineEdit from '@/ui/Input/Content'
import { HEADER as HeaderText, NOITEMS as NoInfothekItems } from '@/state/types/defaultLabel'

class Infothek extends Component {
  static displayName = 'Card / Infothek'
  static propTypes = {
    item: PropTypes.object.isRequired,
  }

  render() {
    const { item, onChange, theme } = this.props
    return (
      <div className={classNames(theme, 'renderpreview', 'infothek-preview')}>
        <InlineEdit
          tagName="h1"
          key="header"
          html={item.header || HeaderText}
          textual
          selectText={HeaderText}
          onChange={(e, value) => onChange(item, 'header', value)}
        />
        <Choose>
          <When condition={item.data && item.data.length}>
            <For each="item" index="indx" of={item.data}>
              <If condition={item.linkurl && item.linktext}>
                <div key={indx}>
                  <a href={item.linkurl}>{item.linktext}</a>
                </div>
              </If>
            </For>
          </When>
          <Otherwise>
            <p className={theme['no-items']} key="warning">
              {NoInfothekItems}
            </p>
          </Otherwise>
        </Choose>
      </div>
    )
  }
}

export default Infothek



// WEBPACK FOOTER //
// ./ui/Blocks/Infothek.js